import { cva } from 'class-variance-authority'

export const cardSizeVariant = cva('rounded bg-white', {
  variants: {
    size: {
      small: 'p-2',
      default: 'p-4'
    }
  }
})
